import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import PlaceholderPage from "./pages/PlaceholderPage/PlaceholderPage";
import Layout from "./pages/Layout/Layout";
import MaintenancePage from "./pages/MaintenancePage/MaintenancePage";
import "./styles/fonts.scss";
import Contact from "./pages/ContactPage/Contact";
import ModelPage from "./pages/ModelPage/ModelPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import ScrollToTop from "./components/Shared/ScrollToTop";
import AccreditationPage from "./pages/AccreditationPage/AccreditationPage";
import GlobalIndexPage from "./pages/Global-IndexPage/GlobalIndexPage";
import TalentSandboxPage from "./pages/Talent-SandboxPage/TalentSandboxPage";
import CenterPage from "./pages/CenterPage/CenterPage";
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />

          <Route path="/froi-about" element={<AboutPage />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="/froi-model" element={<ModelPage />} />

          <Route path="/froi-global-index" element={<GlobalIndexPage />} />

          <Route path="/froi-certification" element={<TalentSandboxPage />} />

          {/* <Route path="/froi-center" element={<CenterPage />} /> */}
          <Route path="/froi-accreditation" element={<AccreditationPage />} />
          <Route path="*" element={<MaintenancePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
